module.exports = __webpack_public_path__ + "img/flex19.993bfd9a.gif";